module.exports = __webpack_public_path__ + "img/service-express-figure.4d8458d.png";